import axios from "axios";
import { signOut } from "next-auth/react";

// Shared function to create axios headers
const createHeaders = () => {
  const correlationId =
    typeof window !== "undefined"
      ? localStorage.getItem("correlationId")
      : null;
  return correlationId
    ? {
        "correlation-id": correlationId,
        "x-cloud-trace-context": correlationId,
      }
    : undefined;
};

// Shared response interceptor logic
const createResponseInterceptor = () => ({
  onFulfilled: (response: any) => response,
  onRejected: async (error: any) => {
    // Don't auto-signOut for authentication endpoint failures - let the login page handle them
    const isAuthEndpoint = error.config?.url?.includes(
      "/api/auth/authenticateUser"
    );

    if (error.status === 401 && !isAuthEndpoint) {
      await signOut({ callbackUrl: "/login?msg=session_expired" });
    }
    return Promise.reject(error);
  },
});

// Setup axios instance with common configuration for frontend use
const setupAxiosInstance = () => {
  // Set global headers if correlationId exists (only on client-side)
  const headers = createHeaders();
  if (headers) {
    axios.defaults.headers.common["correlation-id"] = headers["correlation-id"];
    axios.defaults.headers.common["x-cloud-trace-context"] =
      headers["x-cloud-trace-context"];
  }

  const axiosInstance = axios.create({
    headers: headers,
    timeout: 10000, // 10 second timeout
  });

  const interceptor = createResponseInterceptor();
  axiosInstance.interceptors.response.use(
    interceptor.onFulfilled,
    interceptor.onRejected
  );

  return axiosInstance;
};

export const fetcher = async (url: string, queryParams = "") => {
  const axiosInstance = setupAxiosInstance();
  const res = await axiosInstance.get(`${url}${queryParams}`);
  return res.data;
};

export const clientAxiosInstance = () => {
  return setupAxiosInstance();
};
